import React from 'react';
import SharedFooter from '../../footer/footer';

export default function Footer() {
    return <SharedFooter dark showSocial />;
}
